export const COLORS = {
  BACKGROUND: 0x050520,
  MAZE_WALL: 0x00e5ff,
  MAZE_WALL_GLOW: 0x006680,
  DOT: 0xaaddff,
  PACMAN: 0xffe500,
  PACMAN_GLOW: 0xffaa00,
  GHOST_BLINKY: 0xff3355,
  GHOST_SPEEDY: 0xcc44ff,
  GHOST_CLYDE: 0xffaa33,
  GHOST_INKY: 0x33ddff,
  GHOST_FRIGHTENED: 0x2244bb,
  POWER_PILL: 0xffffff,
  POWER_PILL_GLOW: 0x88ccff,
  SCORE_TEXT: 0xffffff,
  UI_ACCENT: 0x00ff88,
  NEON_PINK: 0xff00aa,
  NEON_GREEN: 0x00ff88,
  NEON_CYAN: 0x00e5ff,
  NEON_YELLOW: 0xffe500,
} as const;

export const COLOR_STRINGS = {
  BACKGROUND: '#050520',
  MAZE_WALL: '#00E5FF',
  DOT: '#AADDFF',
  PACMAN: '#FFE500',
  GHOST_BLINKY: '#FF3355',
  GHOST_SPEEDY: '#CC44FF',
  GHOST_CLYDE: '#FFAA33',
  GHOST_INKY: '#33DDFF',
  GHOST_FRIGHTENED: '#2244BB',
  POWER_PILL: '#FFFFFF',
  SCORE_TEXT: '#FFFFFF',
  NEON_PINK: '#FF00AA',
  NEON_GREEN: '#00FF88',
  NEON_CYAN: '#00E5FF',
  NEON_YELLOW: '#FFE500',
} as const;

/** Shared font families for the neon vector style */
export const NEON_FONTS = {
  /** Bold display font for titles and headings */
  TITLE: '"Orbitron", "Rajdhani", "Segoe UI", sans-serif',
  /** Clean readable font for body text and HUD */
  BODY: '"Rajdhani", "Orbitron", "Segoe UI", sans-serif',
} as const;
